// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';

function lazyLoadHTML(outputIdSelector, ajaxURL) {
  if ($(outputIdSelector).length) {
    $.ajax({
      url: ajaxURL,
      beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        xhr.setRequestHeader('Accept', 'application/javascript');
      },
      type: 'GET',
      timeout: 5000,
    });
  }
}

function onClickLazyLoadHTML(buttonIdSelector, outputIdSelector, ajaxURL){
  let isLoaded = false;
  $(buttonIdSelector).click(()=>{
    if (!isLoaded){
      lazyLoadHTML(outputIdSelector,ajaxURL);
      isLoaded = true;
    }
  });
}

let isTopPageLoaded = false;
$(window).on('load',()=>{
  $(window).scroll(() => {
    if (!isTopPageLoaded) {
      lazyLoadHTML('#top-pickup', '/top_mie_article.js');
      lazyLoadHTML('#daily-event', '/top_event.js');
      lazyLoadHTML('#ranking-spot','/top_ranking_spot.js');
      lazyLoadHTML('#top-theme', '/top_pickup_mie.js');
      lazyLoadHTML('#instagram', '/top_instagram.js');
      isTopPageLoaded = true;
    }
  });
});

onClickLazyLoadHTML('#ranking-report-btn','#ranking-report', '/top_ranking_report.js');
onClickLazyLoadHTML('#ranking-gourmet-btn', '#ranking-gourmet', '/top_ranking_gourmet.js');
onClickLazyLoadHTML('#ranking-event-btn', '#ranking-event', '/top_ranking_event.js');
onClickLazyLoadHTML('#ranking-activity-btn', '#ranking-activity', '/top_ranking_activity.js');
onClickLazyLoadHTML('#ranking-ai-btn', '#recommend_spot', '/top_ai_recommend.js');

// ブラウザ幅が広い時のみ読み込み時グロナビの位置をMV下にする
if (document.querySelector('.miepref-global-header--home') !== null) {
  let gnavFixed = () => {
    const globalHeader = document.querySelector('.miepref-global-header');
    const totopBtn = document.querySelector('.totop-btn--top');
    const globalHeaderHeight = 100;
    const windowHeight = window.innerHeight;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    if (scroll > windowHeight - globalHeaderHeight) {
      globalHeader.classList.remove('is-xl-absolute');
      totopBtn.classList.remove('is-mv-show');
    } else {
      globalHeader.classList.add('is-xl-absolute');
      totopBtn.classList.add('is-mv-show');
    }
  };
  window.addEventListener('load', gnavFixed);
  window.addEventListener('scroll', gnavFixed);
}

// ブラウザ幅が広い時のみMV上に表示される言語選択ボタン
const topMvLangOper = document.querySelector('[data-role="top-mv-lang-opener"]');
if (topMvLangOper != null) {
  topMvLangOper.addEventListener('click', () => {
    topMvLangOper.classList.toggle('is-active');
  });
}
